import * as React from "react";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useSelector, useDispatch } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { approveClaimHeadOffice } from "../../actions/pendingClaims";
import { sendApproverEmail } from "../../actions/verification";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FolderIcon from "@mui/icons-material/Folder";
import { verifyUser } from "../../actions/verification";
import { deleteClaim } from "../../actions/claim";
import { getClaim } from "../../actions/claim";
import { Helmet } from "react-helmet-async";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: "15px",
  p: 4,
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#75CA93 ",
    color: theme.palette.common.black,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
});
function createData(
  id,
  date,
  employee_name,
  branch,
  department,
  category,
  description,
  sanctioned_by,
  amount,
  status
) {
  return {
    id,
    date,
    employee_name,
    branch,
    department,
    category,
    description,
    sanctioned_by,
    amount,
    status,
  };
}
function createData2(id, items) {
  return {
    id,
    items,
  };
}
export default function Approval() {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const verification = JSON.parse(secureLocalStorage.getItem("verify"));
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleOpen1 = () => setOpen1(true);
  const pendings = useSelector((state) => state.pendingClaims);
  const [editingId, setEditingId] = React.useState("");
  const email = user.results.email;
  const claims = useSelector((state) => state.claims.claims);
  const [claimsData, setClaimsData] = React.useState(claims);

  React.useEffect(() => {
    setClaimsData(claims);
  }, [claims]);
  const neededData = claimsData.filter(
    (d) =>
      (d.parent_category === "IMPREST" || d.category === "IMPREST") &&
      d.payment_status === "Paid"
  );
  const neededData2 = claimsData.filter(
    (d) => d.category === "IMPREST" || d.utilisation_approval === "pending"
  );

  const groupedData = neededData2.reduce((result, item) => {
    const { imprest_code } = item;

    if (!result[imprest_code]) {
      result[imprest_code] = {
        imprest_code,
        items: [],
      };
    }

    result[imprest_code].items.push({ ...item });

    return result;
  }, {});

  const formattedData = Object.values(groupedData).map((group) => ({
    imprest_code: group.imprest_code,
    items: group.items.filter(
      (item) => item.category !== "IMPREST" && item.status === "pending"
    ),
  }));
  const row = formattedData.map((data) =>
    createData2(data.imprest_code, data.items)
  );
  const [data, setData] = React.useState(pendings);
  const rows = data
    .filter(
      (item) =>
        (item.attention_to === "Anyone" || item.attention_to === email) &&
        item.parent_category !== "IMPREST"
    )
    .map((data) =>
      createData(
        data._id,
        moment(data.date).format("MM-DD-YYYY"),
        data.employee_name,
        data.branch,
        data.department,
        data.category,
        data.description,
        data.sanctioned_by,
        data.amount,
        data.status
      )
    );
  React.useEffect(() => {
    setData(pendings);
  }, [pendings]);
  const dispatch = useDispatch();
  const [id, setId] = React.useState("");
  const [cost, setCost] = React.useState(0);
  const [verify_code, setVerifyCode] = React.useState("");
  const [verifyClaim, setVerifyClaim] = React.useState(verification);
  const verifyMessage = useSelector((state) => state.verification.response);
  const [updatingOption, setUpdatingOption] = React.useState("");
  const [imprestCode, setImprestCode] = React.useState("");

  const handleClose = () => {
    setId("");
    setCost(0);
    setOpen(false);
  };
  const handleClose1 = () => {
    setId("");
    setOpen1(false);
  };

  React.useEffect(() => {
    setVerifyClaim(verification);
  }, [verification?.message]);
  function sendCode(e) {
    e.preventDefault();
    dispatch(verifyUser(verify_code));
  }
  function sendEmail() {
    dispatch(sendApproverEmail({ email: user.results.email }));
  }
  function handleSave() {
    // after saving the data
    if (updatingOption === "IMPREST") {
      dispatch(
        approveClaimHeadOffice(id, {
          approved_by: user.results.firstName + " " + user.results.lastName,
          status: "approved",
          utilisation_approval: "approved",
          approvers_position: user.results.position,
          approvers_email: user.results.email,
        })
      );

      const mainImprest = neededData.filter(
        (d) => d.claim_code === imprestCode
      );
      const ids = mainImprest[0]?._id;
      const approveUtilised = neededData.filter(
        (d) =>
          d.imprest_code === imprestCode &&
          d.utilisation_approval === "approved"
      );
      const mainImprestAmount = mainImprest[0]?.amount;
      const imprestRefund = mainImprest[0]?.imprest_refund;
      const approvedUtilisedTotal = approveUtilised.reduce(
        (acc, d) => acc + d.amount,
        0
      );
      const nowApproving = neededData.filter((d) => d._id === id);
      const nowApprovingUtilisedTotal = nowApproving.reduce(
        (acc, d) => acc + d.amount,
        0
      );
      const totalAmount =
        nowApprovingUtilisedTotal + imprestRefund + approvedUtilisedTotal;
      if (totalAmount === mainImprestAmount) {
        dispatch(deleteClaim(ids));
      }
      setTimeout(() => {
        dispatch(getClaim());
      }, 1000);

      return;
    }
    dispatch(
      approveClaimHeadOffice(id, {
        amount: cost,
        approved_by: user.results.firstName + " " + user.results.lastName,
        status: "approved",
        approvers_position: user.results.position,
        approvers_email: user.results.email,
      })
    );

    setEditingId("");
    handleClose();
    const removeId = data.filter((data) => data._id !== id);
    setData(removeId);
  }
  function openSave(id, cost, imprest_code) {
    setImprestCode(imprest_code);
    setId(id);
    setCost(cost);
    handleOpen();
  }
  function openDecline(id) {
    setId(id);
    handleOpen1();
    setEditingId("");
  }

  const declineClaim = () => {
    dispatch(approveClaimHeadOffice(id, { status: "declined" }));

    handleClose1();
  };
  const ExpensesRow = ({ expenses }) => {
    const [openTab, setOpenTab] = React.useState(false);
    const id = expenses.id;
    const data = claimsData.filter((d) => d.claim_code === id);

    return (
      <>
        <TableRow style={{ backgroundColor: "#e5e7eb" }}>
          <TableCell>
            <IconButton size='small' onClick={() => setOpenTab(!openTab)}>
              {openTab ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}>
            <FolderIcon />
            {expenses.id} - {data[0]?.employee_name}
          </TableCell>
          <TableCell style={{}}>{data[0]?.amount}</TableCell>
          <TableCell style={{}}>{data[0]?.imprest_refund || 0}</TableCell>
        </TableRow>

        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
            <Collapse in={openTab} timeout='auto' unmountOnExit>
              <Table stickyHeader size='small' aria-label='a dense table'>
                <TableHead style={{ backgroundColor: "#75CA93 " }}>
                  <TableRow style={{ backgroundColor: "#75CA93 " }}>
                    <StyledTableCell align='left'>
                      <em>#</em>
                    </StyledTableCell>
                    <StyledTableCell width={"200px"} align='left'>
                      CODE
                    </StyledTableCell>
                    <StyledTableCell align='left'>DATE</StyledTableCell>
                    <StyledTableCell align='left'>
                      EMPLOYEE NAME
                    </StyledTableCell>
                    <StyledTableCell align='left'>BRANCH</StyledTableCell>
                    <StyledTableCell align='left'>DEPARTMENT</StyledTableCell>
                    <StyledTableCell align='left'>CATEGORY</StyledTableCell>
                    <StyledTableCell align='left'>DESIGNATION</StyledTableCell>
                    <StyledTableCell align='left'>
                      SANCTIONED BY
                    </StyledTableCell>
                    <StyledTableCell align='left'>AMOUNT</StyledTableCell>
                    <StyledTableCell align='left'>
                      PAYMENT STATUS
                    </StyledTableCell>
                    <StyledTableCell align='left'>STATUS</StyledTableCell>
                    <StyledTableCell align='left'>ACTION</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {expenses.items.map((row, index) => (
                    <StyledTableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}>
                      <StyledTableCell align='left' component='th' scope='row'>
                        <em style={{ fontWeight: "bold" }}>{index + 1}</em>
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: "200px" }}
                        align='left'
                        component='th'
                        scope='row'>
                        {row.claim_code}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: "200px" }}
                        align='left'
                        component='th'
                        scope='row'>
                        {moment(row.date).format("MM-DD-YYYY")}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: "200px" }}
                        align='left'>
                        {row.employee_name}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.branch}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.department}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "250px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.category}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "250px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.designation}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.sanctioned_by}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{ minWidth: "200px" }}
                        align='left'>
                        {currencyFormatter.format(row.amount)}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.payment_status}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                        }}
                        align='left'>
                        {row.status}
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          minWidth: "200px",
                          textTransform: "capitalize",
                          display: "flex",
                          flexDirection: "row",
                        }}
                        align='left'>
                        <Paper style={{ width: "fit-content" }}>
                          <Tooltip title='Approve'>
                            <IconButton
                              onClick={() => {
                                openSave(row._id, row.amount, row.imprest_code);
                                setUpdatingOption("IMPREST");
                              }}
                              size='small'>
                              <CheckCircleOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Paper>
                        <Paper style={{ width: "fit-content" }}>
                          <Tooltip title='Decline'>
                            <IconButton
                              onClick={() => openDecline(row.id)}
                              size='small'>
                              <CancelOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </Paper>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  };
  return (
    <div>
      <Helmet title='Approval - eClaim' />
      {verifyClaim ? (
        <Box marginTop={3}>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'>
            <Box sx={style}>
              <Typography id='modal-modal-title' variant='h6' component='h2'>
                CLAIM APPROVAL
              </Typography>
              <Typography id='modal-modal-description' sx={{ mt: 2 }}>
                Are you sure you want to approve this claim?
              </Typography>
              <Button onClick={handleSave}>Yes</Button>
              <Button onClick={handleClose}>Cancel</Button>
            </Box>
          </Modal>
          <Modal
            open={open1}
            onClose={handleClose1}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'>
            <Box sx={style}>
              <Typography id='modal-modal-title' variant='h6' component='h2'>
                DECLINE CLAIM
              </Typography>
              <Typography id='modal-modal-description' sx={{ mt: 2 }}>
                Are you sure you want to decline this claim?
              </Typography>
              <Button onClick={declineClaim}>Yes</Button>
              <Button onClick={handleClose1}>Cancel</Button>
            </Box>
          </Modal>
          <TableContainer
            style={{ marginTop: "100px" }}
            component={Paper}
            elevation={0}>
            <Typography paddingLeft={"10px"} variant='h6'>
              {" "}
              {data.length} pending claims
            </Typography>
            <Table sx={{ minWidth: 700 }} aria-label='customized table'>
              <TableHead style={{ backgroundColor: "#75CA93 " }}>
                <TableRow style={{ backgroundColor: "#75CA93 " }}>
                  <StyledTableCell align='center'>DATE</StyledTableCell>
                  <StyledTableCell align='center'>
                    EMPLOYEE NAME
                  </StyledTableCell>
                  <StyledTableCell align='center'>BRANCH</StyledTableCell>
                  <StyledTableCell align='center'>DEPARTMENT</StyledTableCell>
                  <StyledTableCell align='center'>CATEGORY</StyledTableCell>
                  <StyledTableCell align='center'>DESCRIPTION</StyledTableCell>
                  <StyledTableCell align='center'>
                    SANCTIONED BY
                  </StyledTableCell>
                  <StyledTableCell align='center'>AMOUNT</StyledTableCell>
                  <StyledTableCell align='center'>STATUS</StyledTableCell>
                  <StyledTableCell align='center'>ACTION</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell component='th' scope='row'>
                      {row.date}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      {row.employee_name}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      {row.branch}
                    </StyledTableCell>

                    <StyledTableCell align='center'>
                      {row.department}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      {row.category}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      {row.description}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      {row.sanctioned_by}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      {editingId === row.id ? (
                        <input
                          type='number'
                          style={{ width: "100px" }}
                          value={row.amount}
                          onChange={(e) =>
                            setData((prevData) =>
                              prevData.map((item) =>
                                item._id === row.id
                                  ? { ...item, amount: e.target.value }
                                  : item
                              )
                            )
                          }
                        />
                      ) : (
                        row.amount
                      )}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      {row.status}
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      <Tooltip title='edit'>
                        <IconButton
                          onClick={(e) => setEditingId(row.id)}
                          size='small'>
                          <EditOutlinedIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title='approve'>
                        <IconButton
                          onClick={() => openSave(row.id, row.amount)}
                          size='small'>
                          <CheckCircleOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title='decline'>
                        <IconButton
                          onClick={() => openDecline(row.id)}
                          size='small'>
                          <CancelOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div style={{ marginTop: "20px" }}>
            <Typography
              alignSelf={"center"}
              align='center'
              fontWeight={"bolder"}
              textTransform={"uppercase"}>
              Utilised Imprest Approval
            </Typography>
            <TableContainer component={Paper}>
              <Table size='small' aria-label='collapsible table'>
                <TableHead
                  style={{
                    backgroundColor: "#cccccc",
                    fontWeight: "bold",
                    color: "#fff",
                  }}>
                  <TableRow>
                    <TableCell />
                    <TableCell style={{ fontWeight: "bold", color: "#000000" }}>
                      Imprest Code-Recipient Name
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold", color: "#000000" }}>
                      Amount
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold", color: "#000000" }}>
                      Refund
                    </TableCell>

                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.map((expense, index) => (
                    <ExpensesRow key={index} expenses={expense} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Box>
      ) : (
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}>
            <Typography
              fontWeight={"bolder"}
              id='modal-modal-title'
              variant='h6'
              component='h2'>
              OTP
            </Typography>
            <Typography
              fontWeight={"bolder"}
              id='modal-modal-title'
              variant='h6'
              component='h2'>
              Verification Code
            </Typography>
          </div>
          <Typography
            style={{
              marginBottom: "10px",
              fontSize: "12px",
              marginLeft: "5px",
              color: `${verifyMessage === "Verified" ? "" : "red"}`,
            }}
            id='modal-modal-description'
            sx={{ mt: 2 }}>
            {verifyMessage}
          </Typography>
          <TextField
            size='small'
            type='text'
            label='verification code'
            value={verify_code}
            onChange={(e) => setVerifyCode(e.target.value)}
          />
          <Button
            onClick={sendCode}
            variant='contained'
            style={{
              textTransform: "none",
              margin: "5px",
              backgroundColor: "#0F4C4D",
            }}>
            submit
          </Button>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              alignContent: "center",
              justifyContent: "center",
            }}>
            <button
              style={{
                borderRadius: "5px",
              }}
              onClick={sendEmail}>
              Click to receive code.
            </button>
          </div>
        </Box>
      )}
    </div>
  );
}
